import type {
  IBulkPushNotification,
  ISinglePushNotification,
} from '@/types/PushNotification';

import axios from './axios';

// Send Push Notification
export async function sendBulkPushNotification(
  notificationDetails: IBulkPushNotification,
): Promise<unknown> {
  const response = await axios.post<unknown>(
    '/v2/admin/notifications/all',
    notificationDetails,
  );
  return response.data;
}

export async function sendSinglePushNotification(
  notificationDetails: ISinglePushNotification,
): Promise<unknown> {
  const response = await axios.post<unknown>(
    '/v2/admin/notifications/single',
    notificationDetails,
  );
  return response.data;
}
